import {FC, ReactNode, useEffect, useState} from 'react'
import './InvoiceSubject.css'
import {FieldHelpLabel} from '../../../../../../_metronic/helpers/components/FieldHelp'

type Props = {
  title: string
  hasValue: boolean
  children: ReactNode
  className?: string
}

const AutoOpenOptionalSection: FC<Props> = ({title, hasValue, children, className = ''}) => {
  const [open, setOpen] = useState(hasValue)

  useEffect(() => {
    if (hasValue) {
      setOpen(true)
    }
  }, [hasValue])

  return (
    <details
      className={`mp-optional-section ${className}`.trim()}
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary>
        <span>
          <i className='las la-plus-circle' aria-hidden='true'></i>
          <FieldHelpLabel label={title} />
        </span>
        <small>{open ? 'بستن' : 'مشاهده و تکمیل'}</small>
      </summary>
      <div className='mp-optional-section__body'>{children}</div>
    </details>
  )
}

export {AutoOpenOptionalSection}
